export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=7049cb8750129f113bb5c2c306f751880c5579acbe&name=pushAdClickData!'